/** Définition des stratégies à utiliser pour récupérer un id de base de données parmi plusieurs. */
export enum EMultipleDatabaseIdsStrategy {
	TAKE_FIRST,
	THROW_ERROR
}